<div
  *ngIf="!fieldAttribute.hidden"
  [formGroup]="form"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="bottom auto"
      [ngbTooltip]="fieldAttribute.backendAttribute.placeholder | translate"
      triggers="click:blur"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <input
    [class.is-invalid]="isFieldInvalid()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [type]="fieldAttribute.backendAttribute.type_attribute"
    [formControlName]="fieldAttribute.backendAttribute.name"
    [id]="fieldAttribute.id"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
    [minlength]="fieldAttribute.backendAttribute.min_length"
    (blur)="onBlur()"
  />
  <div class="d-flex">
    <small
      *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
      class="d-flex mt-1 invalid-feedback"
      [attr.data-test-id]="fieldAttribute.errorDataTestId"
    >
      {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
    </small>

    <app-counter
      *ngIf="
        !fieldAttribute.backendAttribute.counter_hide &&
        fieldAttribute.backendAttribute.max_length &&
        !fieldAttribute.backendAttribute.read_only
      "
      class="ms-auto mt-1"
      [maxLength]="fieldAttribute.backendAttribute.max_length"
      [isFieldInvalid]="fieldAttribute.backendAttribute.max_length < control.value?.length"
      [dataTestId]="fieldAttribute.elementDataTestId"
      [valueLength]="control.value?.length"
    >
    </app-counter>
  </div>
</div>
